import * as $ from 'jquery';

$(document).on( 'click', '.selected-lang-en', function () { 
	$( this ).closest(".lang-select").addClass( 'en-lang' );
	$( this ).closest(".lang-select").removeClass( 'de-lang' );
});
$(document).on( 'click', '.selected-lang-de', function () {
	$( this ).closest(".lang-select").addClass( 'de-lang' );
	$( this ).closest(".lang-select").removeClass( 'en-lang' );
}); 
$(document).on( 'click', '.dropdown .dropdown-toggler', function () {
	$(this).closest('.dropdown').find('.dropdown-menu').toggle();
}); 
$(document).on( 'click', '#remove-cat-disable', function () {
	$('.category_disabled').attr('disabled','true');
});
$(document).on( 'click', '.quesTableToggle', function () {
	$( this ).closest(".quesList").find('.quesTable').slideToggle('slow');
});